













import { Vue, Component, Prop } from 'vue-property-decorator';
import Arrow from '@/components/icons/Arrow.vue';

@Component({
  components: {
    Arrow
  }
})
export default class ArrowWithBorder extends Vue {
  @Prop({ default: '#3E24D6' }) fill!: string;
  @Prop({ default: 'right' }) direction!: 'up' | 'down' | 'left' | 'right';
  @Prop({ default: '30px' }) size!: string;
  @Prop({ default: '10' }) arrowWidth!: string;
  @Prop({ default: '6' }) arrowHeight!: string;
}
